/**
 * Maximum length of a question, enforced by the backend
 * (see ChatRequestSerializer in alda_ai/api/training_chat_views.py).
 * Keep in sync with the server-side max_length.
 */
export const MAX_QUESTION_LENGTH = 100;

export type ChatRole = "user" | "assistant";

export interface ChatMessage {
  id: string;
  role: ChatRole;
  message: string;
}

/** Server-side history entry (no client-only id). */
export interface ChatHistoryEntry {
  role: ChatRole;
  message: string;
}

/** Response from GET .../chat/ — existing conversation if any. */
export interface ChatHistoryResponse {
  session_id?: string;
  history: ChatHistoryEntry[];
}

/** Body for POST .../chat/ — new question. */
export interface ChatPostRequest {
  question: string;
  session_id?: string;
}

/** Response from POST .../chat/ — full updated conversation. */
export interface ChatPostResponse {
  session_id: string;
  answer: string;
  history: ChatHistoryEntry[];
}
